import React, { useState } from "react";
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar } from "@material-ui/core";

export interface IToast {
  msg?: string;
  type: 'default' | 'success' | 'info' | 'error' | 'warning';
}

export function Alert(props: any) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export interface ToastInstance {
  toast: IToast;
  info: (msg: string) => void;
  fail: (msg: string) => void;
  warn: (msg: string) => void;
  success: (msg: string) => void;
  close: () => void;
}

export const useToast = (): ToastInstance => {

  const [toast, setToast] = useState<IToast>({ type: 'info' });

  const info = (msg: string) => setToast({ msg: msg, type: 'info' });
  const fail = (msg: string) => setToast({ msg: msg, type: 'error' });
  const success = (msg: string) => setToast({ msg: msg, type: 'success' });
  const warn = (msg: string) => setToast({ msg: msg, type: 'warning' });
  const close = () => setToast(x => ({ type: x.type, msg: undefined }));

  return { toast, info, fail, warn, success, close };
}

export const MySnackToast = ({ ti }: { ti: ToastInstance }) => {

  // const handleClose = () => {
  //   if (ti && ti.close)
  //     to.close();
  // }

  // const [open, setOpen] = useState(false);

  // useEffect(() => {
  //   setOpen(ti.toast?.msg !== undefined);
  //   // setTimeout(() => {
  //   //   setOpen(false)
  //   // }, 3000);
  // }, [ti.toast]);

  return <div>
    {ti.toast.msg && <Snackbar open={ti.toast.msg !== undefined} autoHideDuration={3000} onClose={ti.close}>
      <Alert onClose={ti.close} severity={ti.toast?.type}>
        {ti.toast?.msg}
      </Alert>
    </Snackbar>}
  </div>
    
};